<template>
  <div class="dr-column" :style="{'align-items':alignItems,'justify-content':justifyContent,}" @click="click($event)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props:{
    alignItems:{
      type:String,
      default:'',//'center：居中','end：居尾'
    },
    justifyContent:{
      type:String,
      default:'',//'space-between：两边','space-around：居中'
    }
  },
  methods:{
    click(event) {
      this.$emit('click',event)
      // this.$emit('click')
    }
  }
}
</script>

<style scoped>
.dr-column {
  display: flex;
  flex-flow: column;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/drColumn/index.vue